import { t } from "@/i18n-js/instance";
import emptyMembers1x from "@/react/components/shared/MembersList/CommunityMembers/images/emptyMembers.png";
import emptyMembers2x from "@/react/components/shared/MembersList/CommunityMembers/images/emptyMembers@2x.png";
import emptyMembers3x from "@/react/components/shared/MembersList/CommunityMembers/images/emptyMembers@3x.png";
import { ProgressiveImage } from "@/react/components/shared/ProgressiveImage";
import { Typography } from "@/react/components/shared/uikit/Typography";

const emptyMembersImageVariants = {
  thumbnail: emptyMembers1x,
  small: emptyMembers2x,
  medium: emptyMembers3x,
  large: emptyMembers3x,
};

export const EmptyState = () => (
  <div className="flex flex-col items-center justify-center">
    <div className="mt-14 flex flex-1 items-center justify-center">
      <ProgressiveImage
        className="w-72"
        src={emptyMembersImageVariants.large}
        srcVariants={emptyMembersImageVariants}
        alt={t("members_directory.no_members.title")}
      />
    </div>
    <div className="mt-16 flex max-w-[440px] flex-col items-center justify-center gap-2">
      <Typography.TitleMd size="text-xl">
        {t("profile_drawer.connections.empty_state.title")}
      </Typography.TitleMd>
      <Typography.BodySm color="text-default" textAlign="text-center">
        {t("profile_drawer.connections.empty_state.subtitle")}
      </Typography.BodySm>
    </div>
  </div>
);
